<template>
  <v-select
    v-model="items.property"
    class="mb-2"
    color="primary"
    :label="getLabel(paramValues.label)"
    variant="outlined"
    density="compact"
    :items="items.options"
    :hint="items.doc"
  ></v-select>
  {{ items.valuesTo }}
</template>

<script>
import { inject, toRefs, reactive, watch } from "vue";
import { updateParameters } from "@/mixins/common-utils.js";
import { useI18n } from "vue-i18n";

export default {
  props: ["paramValues", "initValue"],
  setup(props) {
    const { t, te } = useI18n();
    const formData = inject("formData");
    const parameters = JSON.parse(JSON.stringify(props.paramValues));
    if (!parameters.property) {
      parameters.property = props.initValue ? props.initValue : "";
    }
    const state = reactive({
      valid: inject("valid"),
      items: parameters,
    });
    const { valid, items } = toRefs(state);

    const getLabel = (label) => {
      const labelKey = "labels." + label.toLowerCase().replace(/\s+/g, "-");
      return te(labelKey) ? t(labelKey) : label;
    };

    watch(
      items,
      (newItems) => {
        formData.parameters = updateParameters(newItems, formData.parameters);
      },
      { deep: true, immediate: true },
    );

    return {
      formData,
      valid,
      items,
      getLabel,
    };
  },
};
</script>
